/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Casts the public API for delta manager into the internal one,
 * exposing access to APIs needed by the implementation of Fluid Framework but not its users.
 * @legacy
 * @alpha
 */
export function toDeltaManagerInternal(deltaManager) {
    return deltaManager;
}
/**
 * Casts the the internal API for delta manager into the public type erased API for returning from public APIs that should not have access to any of its members.
 * @internal
 */
export function toDeltaManagerErased(deltaManager) {
    return deltaManager;
}
//# sourceMappingURL=deltaManager.js.map